import React, { useState } from 'react';
import axios from 'axios';
import './MailingListForm.css'
import { Zoom } from 'react-awesome-reveal';

const MailingListForm = ({ onSuccess }) => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Trim input before sending
    const payload = {
      email: email.trim(),
    };

    const apiKey = process.env.REACT_APP_CHATTERS_API_KEY;
    const apiUri = process.env.REACT_APP_CHATTERS_API_URI;

    try {
      const response = await axios.post(
        `${apiUri}/subscribe-to-mailing-list`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': apiKey,  // Send API key for authentication
          },
        }
      );

      if (response.status === 200) {
        setMessage("Thank you for subscribing to our mailing list!");
      }

      //Delay before closing modal
      setTimeout(() => {
        if (onSuccess) onSuccess();
      }, 5000);

    } catch (error) {
      setMessage(
        error.response ? error.response.data.error : 'An error occurred while subscribing.'
      );
    }
  };

  return (
    <div className='mailing_subscribe_container'>
      <h2 className='mailing_header'>JOIN OUR MAILING LIST</h2>
      <span className='mailing_note'>Keep up to date with the latest events at Chatters</span>
      <form onSubmit={handleSubmit}>
        <div className='mailing_subscribe_wrapper'>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
          />
        </div>
        <button type="submit">Subscribe</button>
      </form>
      <span className="mailing_privacy_note">We respect your privacy</span>

      <Zoom className='zoom-container' triggerOnce={true}>
        {message && <span className='mailing_note' style={{marginTop:'20px'}}>{message}</span>}
      </Zoom>
    </div>
  );
};

export default MailingListForm;

// Add?
// We will of course keep your data safe and secure and if you change your mind you can unsubscribe at any time on any marketing email or by emailing info@thelittlechartroom.com.
